import {translations} from './globals';

export default function translate(key) {
  if (!translations.hasOwnProperty(key)) {
    console.error(`"${key}" is not a translated string.`);
  }
  return translations[key];
}
